module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Leuggern-c6bdc82ba8c1f2d63391587650b1fc08.svg";